<div class="flex flex-col items-center p-8">
  <mat-icon [size]="96" color="var(--p-text-muted-color)">{{ icon }}</mat-icon>
  <div class="text-xl font-bold text-muted-color-emphasis">{{ title }}</div>
  <div class="text-muted-color mt-1">{{ subtitle }}</div>
  @if (showButton) {
    <p-button class="mt-4" [label]="buttonText" [outlined]="true" severity="secondary" (onClick)="buttonAction()" />
  }
</div>
